import { clearMaximo } from "../../../../services";

async function clearAllFromMaximo(clearDb, toclearMaximo, checkVersions) {
  return await clearMaximo(clearDb, toclearMaximo, checkVersions);
}

export default clearAllFromMaximo;
